"use client";

import React, { useState } from "react";
import { motion } from "framer-motion";
import { Instagram, Facebook, Linkedin, Mail } from "lucide-react";

const teamMembers = {
  "2026": [
    { id: 1, firstName: "Emna", lastName: "Megdiche", position: "Chair", image: "/asset/team/emnamegdiche.webp", social: { instagram: "https://www.instagram.com/emna_megdiche3/", facebook: "https://www.facebook.com/mannou.megdiche", linkedin: "https://www.linkedin.com/in/emna-megdiche-1997b225a/", email: "emna@example.com" } },
    { id: 2, firstName: "Aziz", lastName: "Alimi", position: "Vice-Chair", image: "/asset/team/alimi2.webp", social: { instagram: "https://www.instagram.com/azizalimi_/", facebook: "https://www.facebook.com/aziz.alimi.3", linkedin: "https://www.linkedin.com/in/aziz-alimi-3717a333a/", email: "aziz@example.com" } },
    { id: 3, firstName: "Yosra", lastName: "Teieb", position: "Membership Coordinator", image: "/asset/team/yosrateieb.webp", social: { instagram: "https://www.instagram.com/yosra._.teieb/", facebook: "https://www.facebook.com/yosra.teieb.2025", linkedin: "https://www.linkedin.com/in/yosra-teieb/", email: "yosra@example.com" } },
    { id: 4, firstName: "Fedi", lastName: "Triki", position: "Project Manager", image: "/asset/team/feditriki.webp", social: { instagram: "https://www.instagram.com/trikifedi7/", facebook: "https://www.facebook.com/fedi.triki.121", linkedin: "https://www.linkedin.com/in/fedi-triki/", email: "fedi@example.com" } },
    { id: 5, firstName: "AbdelKader", lastName: "Barkia", position: "Treasurer", image: "/asset/team/gaddour.webp", social: { instagram: "https://www.instagram.com/abdelkader_barkia/", facebook: "https://www.facebook.com/abdelkader.barkia.2025", linkedin: "https://www.linkedin.com/in/abdelkader-barkia-0312b3357/", email: "abdelkader@example.com" } },
    { id: 7, firstName: "Roua", lastName: "Zouawi", position: "Secretary", image: "/asset/team/rourou.webp", social: { instagram: "https://www.instagram.com/roua__zouawi/", facebook: "https://www.facebook.com/spamm.pikaa", linkedin: "https://www.linkedin.com/in/roua-zouawi-b256bb275/", email: "roua@example.com" } },
    { id: 6, firstName: "Mohamed", lastName: "Tounsi", position: "WebMaster", image: "/asset/team/tounsi.webp", social: { instagram: "https://www.instagram.com/mohamed__tounsii/", facebook: "https://www.facebook.com/mohamed.tounsi.583", linkedin: "https://www.linkedin.com/in/mohamed-tounsi-541439351/", email: "mohamed@example.com" } },
    { id: 8, firstName: "Elee", lastName: "Abidi", position: "Media Manager", image: "/asset/team/elee.webp", social: { instagram: "https://www.instagram.com/elee__abidi/", facebook: "https://www.facebook.com/elee.abidi.7", linkedin: "https://www.linkedin.com/in/elee-abidi-68ab8432a/", email: "elee@example.com" } },
    { id: 10, firstName: "Emna", lastName: "Awadni", position: "Mentor", image: "/asset/team/emnaaw.webp",
      social: { instagram: "https://www.instagram.com/emnaawadni/", facebook: "https://www.facebook.com/emna.awadni", linkedin: "https://www.linkedin.com/in/emna-awadni-a50b692b1/", email: "emna@example.com" } },
    { id: 9, firstName: "Ilhem", lastName: "Kallel", position: "Counselor", image: "/asset/team/mrsilhem.webp", social: { instagram: "https://www.instagram.com/ilhem_kallel/", facebook: "https://www.facebook.com/ikallel", linkedin: "https://www.linkedin.com/in/ilhem-kallel-78699b36/", email: "ilhem@example.com" } },
  ],
  "2025": [
    { id: 1, firstName: "Emna", lastName: "Awadni", position: "Chair", image: "/asset/team/emnaaw.webp",
      social: { instagram: "https://www.instagram.com/emnaawadni/", facebook: "https://www.facebook.com/emna.awadni", linkedin: "https://www.linkedin.com/in/emna-awadni-a50b692b1/", email: "emna@example.com" } },

    { id: 2, firstName: "Yassine", lastName: "Kaffel", position: "Vice-Chair", image: "/asset/team/kaffel.png",
      social: { instagram: "https://www.instagram.com/yassine_kaffel/", facebook: "https://www.facebook.com/Yassine.kaffel65", linkedin: "https://www.linkedin.com/in/kaffel-yassine-849b7b2b9/", email: "aziz@example.com" } },

    { id: 3, firstName: "Emna", lastName: "Megdiche", position: "HR Manager", image: "/asset/team/emnamag.png",
      social: { instagram: "https://www.instagram.com/emna_megdiche3/", facebook: "https://www.facebook.com/mannou.megdiche", linkedin: "https://www.linkedin.com/in/emna-megdiche-1997b225a/", email: "yosra@example.com" } },

    { id: 4, firstName: "Med Aziz", lastName: "Mesfar", position: "Tech Project Manager", image: "/asset/team/aziz2.png",
      social: { instagram: "https://www.instagram.com/med_aziz_mesfar/", facebook: "https://www.facebook.com/medaziz.mesfar", linkedin: "https://www.linkedin.com/in/med-aziz-mesfar-a16b092a0/", email: "fedi@example.com" } },

    { id: 10, firstName: "Anja", lastName: "Ncib", position: "Non-Tech Project Manager", image: "/asset/team/anja.png",
      social: { instagram: "https://www.instagram.com/anja_nc/", facebook: "https://www.facebook.com/ncib.anjouja", linkedin: "https://www.linkedin.com/in/anja-ncib/", email: "fedi@example.com" } },

    { id: 5, firstName: "Salmen", lastName: "Khabou", position: "Treasurer", image: "/asset/team/salmen.png",
      social: { instagram: "https://www.instagram.com/salmen_khabou/", facebook: "https://www.facebook.com/salmenkhabou.kh7", linkedin: "https://www.linkedin.com/in/khabou-salmen-287b441b5/", email: "abdelkader@example.com" } },

    { id: 7, firstName: "Nour", lastName: "Ajili", position: "Secretary", image: "/asset/team/nouraj.png",
      social: { instagram: "https://www.instagram.com/nourajili12/", facebook: "https://www.facebook.com/nour.ajili.7", linkedin: "https://linkedin.com/in/nour_ajili", email: "roua@example.com" } },

    { id: 8, firstName: "Elee", lastName: "Abidi", position: "Media Manager", image: "/asset/team/elee1.png",
      social: { instagram: "https://www.instagram.com/elee__abidi/", facebook: "https://www.facebook.com/elee.abidi.7", linkedin: "https://www.linkedin.com/in/elee-abidi-68ab8432a/", email: "elee@example.com" } },

    { id: 6, firstName: "Med Amin", lastName: "Mallek", position: "WebMaster", image: "/asset/team/amin.png",
      social: { instagram: "https://www.instagram.com/mallekamin30/", facebook: "https://www.facebook.com/amin.mallek.3", linkedin: "https://www.linkedin.com/in/amin-mallek-a45aaa285/", email: "mohamed@example.com" } },

    { id: 9, firstName: "Ilhem", lastName: "Kallel", position: "Counselor", image: "/asset/team/mrsilhem.webp",
      social: { instagram: "https://www.instagram.com/ilhem_kallel/", facebook: "https://www.facebook.com/ikallel", linkedin: "https://www.linkedin.com/in/ilhem-kallel-78699b36/", email: "ilhem@example.com" } },
  ],

  "2024": [
    { id: 1, firstName: "Eya", lastName: "Chaaben", position: "Chair", image: "/asset/team/eya2024.png",
      social: { instagram: "https://www.instagram.com/eyaa_chaaben", facebook: "https://www.facebook.com/Eyaa.Chaabene", linkedin: "https://www.linkedin.com/in/eya-chaabene-b33369278", email: "emna@example.com" } },

    { id: 2, firstName: "Anis", lastName: "Charfi", position: "Vice-Chair", image: "/asset/team/anis.jpg",
      social: { instagram: "https://www.instagram.com/anis_charfi", facebook: "https://www.facebook.com/search/top?q=anis%20charfi", linkedin: "https://www.linkedin.com/in/anis-charfi-aa39b2218", email: "aziz@example.com" } },

    { id: 5, firstName: "Yassine", lastName: "Kaffel", position: "Treasurer", image: "/asset/team/kaffel.png",
      social: { instagram: "https://www.instagram.com/yassine_kaffel/", facebook: "https://www.facebook.com/Yassine.kaffel65", linkedin: "https://www.linkedin.com/in/kaffel-yassine-849b7b2b9/", email: "abdelkader@example.com" } },

    { id: 7, firstName: "Emna", lastName: "Awadni", position: "Secretary", image: "/asset/team/emnaaw.png",
      social: { instagram: "https://www.instagram.com/emnaawadni/", facebook: "https://www.facebook.com/emna.awadni", linkedin: "https://www.linkedin.com/in/emna-awadni-a50b692b1/", email: "roua@example.com" } },

    { id: 6, firstName: "Aya", lastName: "Aidi", position: "WebMaster",
      image: "/asset/team/none.webp",
      social: { instagram: "https://www.instagram.com/aya.aidi.96", facebook: "https://www.facebook.com/aya.aidi.96", linkedin: "https://www.linkedin.com/in/aya-aidi-b105ab2a2", email: "mohamed@example.com" } },

    { id: 9, firstName: "Ilhem", lastName: "Kallel", position: "Counselor", image: "/asset/team/mrsilhem.webp",
      social: { instagram: "https://www.instagram.com/ilhem_kallel/", facebook: "https://www.facebook.com/ikallel", linkedin: "https://www.linkedin.com/in/ilhem-kallel-78699b36/", email: "ilhem@example.com" } },
  ],

  "2023": [
    { id: 1, firstName: "Emna", lastName: "Sahnoun", position: "Chair", image: "/asset/team/sahnoun.jpg",
      social: { instagram: "https://www.instagram.com/emna_sahnoun_", facebook: "https://www.facebook.com/emna.sahnoun.56", linkedin: "https://www.linkedin.com/in/emna-sahnoun-2816aa202", email: "emna@example.com" } },

    { id: 2, firstName: "Karim", lastName: "Guermazi", position: "Vice-Chair", image: "/asset/team/karim.jpg",
      social: { instagram: "https://www.instagram.com/karim.guermazi", facebook: "https://www.facebook.com/karim.guermazi.3", linkedin: "https://www.linkedin.com/in/karim-guermazi-0b538518b", email: "aziz@example.com" } },

    { id: 5, firstName: "Mariem", lastName: "Mnif", position: "Treasurer", image: "/asset/team/mnif.jpg",
      social: { instagram: "https://www.instagram.com/mariem_mnif_3", facebook: "https://www.facebook.com/mariem.mnif.2025", linkedin: "https://www.linkedin.com/in/mariem-mnif-579034231", email: "abdelkader@example.com" } },

    { id: 7, firstName: "Eya", lastName: "Guirat", position: "Secretary", image: "/asset/team/guirat.jpg",
      social: { instagram: "https://www.instagram.com/eya.guirat", facebook: "https://www.facebook.com/eya.guirat.2025", linkedin: "https://www.linkedin.com/in/eya-guirat-67594b22a", email: "roua@example.com" } },

    { id: 6, firstName: "Baha eddine", lastName: "Chalbia", position: "WebMaster", image: "/asset/team/baha.jpg",
      social: { instagram: "https://www.instagram.com/bahachoi", facebook: "https://www.facebook.com/baha.chalbia.4", linkedin: "https://www.linkedin.com/in/baha-eddine-chalbia", email: "mohamed@example.com" } },

    { id: 9, firstName: "Ilhem", lastName: "Kallel", position: "Counselor", image: "/asset/team/mrsilhem.webp",
      social: { instagram: "https://www.instagram.com/ilhem_kallel/", facebook: "https://www.facebook.com/ikallel", linkedin: "https://www.linkedin.com/in/ilhem-kallel-78699b36/", email: "ilhem@example.com" } },
  ]
};

const years = ["2026", "2025", "2024", "2023"];

// Returns which members go in full rows vs the last partial row,
// and how many columns to use for centering on each breakpoint.
function splitMembers(members, cols) {
  const remainder = members.length % cols;
  if (remainder === 0) {
    return { fullRows: members, lastRow: [] };
  }
  return {
    fullRows: members.slice(0, members.length - remainder),
    lastRow: members.slice(members.length - remainder),
  };
}

export default function Team() {
  const [selectedYear, setSelectedYear] = useState("2026");

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3,
      },
    },
  };

  const members = teamMembers[selectedYear];

  // Columns per breakpoint: mobile=2, sm=2, lg=3, xl=4
  // We calculate last-row remainders for each breakpoint.
  // For the centered last row we render a separate flex row.
  // Columns per breakpoint: mobile=1, sm=2, lg=3, xl=4
  // We use xl (4 cols) as the "PC" reference.
  const xlCols = 4;
  const { fullRows, lastRow } = splitMembers(members, xlCols);

  return (
    <section id="team" className="relative w-full min-h-screen bg-[#f4f7f9] py-[40px] md:py-24 lg:py-32 overflow-hidden">
      {/* Background Texture - Original Lines Restored */}
      <div
        className="absolute inset-0 pointer-events-none opacity-60"
        style={{
          backgroundImage: `
            repeating-linear-gradient(
              -45deg,
              rgba(15, 105, 157, 0.035) 0px,
              rgba(15, 105, 157, 0.035) 1px,
              transparent 1px,
              transparent 18px
            ),
            repeating-linear-gradient(
              45deg,
              rgba(15, 105, 157, 0.025) 0px,
              rgba(15, 105, 157, 0.025) 1px,
              transparent 1px,
              transparent 28px
            )
          `,
        }}
      />
      <div className="absolute inset-0 opacity-[0.15] mix-blend-overlay pointer-events-none" style={{ backgroundImage: "url('https://grainy-gradients.vercel.app/noise.svg')" }} />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10">
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-start"
        >
          <h2 className="text-[#006699] font-bold tracking-widest uppercase text-sm mb-2 border-l-[3px] border-[#006699] pl-3">
            Leadership Team
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#002233] leading-tight">
            Meet Our <br />
            <span className="text-[#006699]">Executive Committee</span>
          </h3>

          {/* Year Filter Buttons */}
          <div className="flex flex-wrap gap-2 md:gap-3 pt-8">
            {years.map((year) => (
              <button
                key={year}
                onClick={() => setSelectedYear(year)}
                className={`px-5 py-2.5 text-sm md:text-base font-bold transition-all duration-300 rounded-none border-[2px] ${
                  selectedYear === year
                    ? "bg-[#006699] border-[#006699] text-white shadow-lg shadow-[#006699]/30"
                    : "bg-transparent border-[#006699]/20 text-[#006699] hover:bg-[#006699]/10"
                }`}
              >
                {year}
              </button>
            ))}
          </div>
        </motion.div>

        {/* Full rows grid */}
        {fullRows.length > 0 && (
          <motion.div
            key={`full-${selectedYear}`}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-8 pt-12"
          >
            {fullRows.map((member, index) => (
              <TeamCard key={member.id} member={member} index={index} />
            ))}
          </motion.div>
        )}

        {/* Last partial row — centered */}
        {lastRow.length > 0 && (
          <motion.div
            key={`last-${selectedYear}`}
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="flex flex-wrap justify-center gap-6 sm:gap-8 pt-10"
          >
            {lastRow.map((member, index) => (
              <div
                key={member.id}
                className="w-[calc(50%-0.75rem)] sm:w-[calc(50%-1.5rem)] lg:w-[calc(33.333%-2rem)] xl:w-[calc(25%-1.5rem)]"
              >
                <TeamCard
                  member={member}
                  index={fullRows.length + index}
                />
              </div>
            ))}
          </motion.div>
        )}
      </div>
    </section>
  );
}

function TeamCard({ member, index }) {
  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        delay: index * 0.1,
        ease: "easeOut",
      },
    },
  };

  return (
    <motion.div
      variants={cardVariants}
      className="group relative bg-white w-full transform transition-all duration-300 hover:-translate-y-2 shadow-[0_2px_4px_rgba(0,0,0,0.02)] hover:shadow-[0_6px_15px_rgba(0,102,153,0.08)]"
    >
      {/* Sliding Border Lines */}
      {/* Top Line: starts TL, slides right to TR */}
      <div className="absolute top-0 left-0 h-[2px] bg-[#006699] w-8 transition-all duration-700 ease-in-out z-30 pointer-events-none group-hover:left-[calc(100%-2rem)]" />
      {/* Bottom Line: starts BR, slides left to BL */}
      <div className="absolute bottom-0 right-0 h-[2px] bg-[#006699] w-8 transition-all duration-700 ease-in-out z-30 pointer-events-none group-hover:right-[calc(100%-2rem)]" />
      {/* Left Line: starts TL, slides down to BL */}
      <div className="absolute top-0 left-0 w-[2px] bg-[#006699] h-8 transition-all duration-700 ease-in-out z-30 pointer-events-none group-hover:top-[calc(100%-2rem)]" />
      {/* Right Line: starts BR, slides up to TR */}
      <div className="absolute bottom-0 right-0 w-[2px] bg-[#006699] h-8 transition-all duration-700 ease-in-out z-30 pointer-events-none group-hover:bottom-[calc(100%-2rem)]" />

      {/* Image Container with Background for Transparent Images */}
      <div className="relative aspect-[2/3] overflow-hidden bg-gradient-to-b from-[#e8eef3] to-[#d0dbe3] w-full h-full">
        <img
          src={member.image}
          alt={`${member.firstName} ${member.lastName}`}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />

        {/* Social Icons (Hidden by default, staggered on hover) */}
        <div className="absolute top-4 right-4 flex flex-col gap-2 z-20">
          {member.social.instagram && (
            <div className="opacity-0 translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200 ease-out" style={{ transitionDelay: '0ms' }}>
              <SocialIcon href={member.social.instagram} platform="instagram" />
            </div>
          )}
          {member.social.facebook && (
            <div className="opacity-0 translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200 ease-out" style={{ transitionDelay: '75ms' }}>
              <SocialIcon href={member.social.facebook} platform="facebook" />
            </div>
          )}
          {member.social.linkedin && (
            <div className="opacity-0 translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200 ease-out" style={{ transitionDelay: '150ms' }}>
              <SocialIcon href={member.social.linkedin} platform="linkedin" />
            </div>
          )}
        </div>

        {/* Gradient Overlay for Text Visibility */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#002233]/90 via-[#002233]/10 to-transparent opacity-70 group-hover:opacity-80 transition-opacity duration-300 pointer-events-none" />

        {/* Text Details */}
        <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-5 flex flex-col items-start z-10 text-left">
          {/* POSITION */}
          <p className="text-lg sm:text-xl font-bold text-white uppercase tracking-wide leading-tight drop-shadow-sm transform transition-transform duration-300 group-hover:-translate-y-1">
            {member.position}
          </p>
          {/* NAME */}
          <h3 className="text-sm sm:text-base font-medium text-gray-300 leading-snug mt-1 drop-shadow-sm transform transition-transform duration-300 group-hover:-translate-y-1">
            {member.firstName} <span className="font-light">{member.lastName}</span>
          </h3>
        </div>
      </div>
    </motion.div>
  );
}

function SocialIcon({ href, platform }) {
  const icons = {
    instagram: Instagram,
    facebook: Facebook,
    linkedin: Linkedin,
    email: Mail,
  };

  const Icon = icons[platform];

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      whileHover={{ scale: 1.2, opacity: 0.8 }}
      whileTap={{ scale: 0.95 }}
      className="w-8 h-8 flex items-center justify-center bg-[#002233]/70 backdrop-blur-sm border border-white/20 text-white hover:bg-[#006699] transition-all duration-300"
    >
      <Icon size={18} strokeWidth={1.5} />
    </motion.a>
  );
}